import { pickBy } from 'lodash/fp';

const cleanEmptyValues = pickBy((value) => {
  if (Array.isArray(value)) {
    return value.length > 0;
  } else if (typeof value === 'object' && value !== null) {
    value = cleanEmptyValues(value);

    return Object.keys(value).length > 0;
  }

  return value === 0 || value;
});

export default cleanEmptyValues;
